// extracted by mini-css-extract-plugin
export default {"nav":"SiblingNav_nav__1u3LJ","button":"SiblingNav_button__VXoYZ"};